export const GET_USER_INITIAL_INFO = `query GetUserInitialInfo {
    campaignPlans(first: 1) {
        edges {
            node {
                id
            }
        }   
    }
    me {
        id
        email
        roles {
            id
            type
            merchant {
                id
                name
                logo
                logoBgColor
            }
        }
    }
    waffle {
        flags {
            name
            isActive
        }
    }
}`;
